export const AUDIT_API = '/api/Audit/search';
export const ALIGNE_AUDIT_API = '/api/Audit/AligneAudit';
export const NOMINATION_AUDIT_API = '/api/Nomination/AutomationAudit';
